export default __webpack_public_path__ + "static/media/token-logo.734afc88.png";